import { createAction } from "redux-actions";
//
import { createPromiseActionTypes } from "../../utils/redux";
import Api from "../../services/Api";
import { getReviewsPage } from "../../selectors";

//  Actions Types
export const REVIEWS_GET = createPromiseActionTypes("reviews/REVIEWS_GET");

//  Actions
const getReviewsPendingAction = createAction(REVIEWS_GET.PENDING);
const getReviewsFulfilledAction = createAction(REVIEWS_GET.FULFILLED);
const getReviewsRejectedAction = createAction(REVIEWS_GET.REJECTED);

export const getReviewsAction = (payload) => async (dispatch, getState) => {
  const state = getState();
  const page = getReviewsPage(state);
  const payload = { modelId: state.models.active, page: page + 1 };

  dispatch(getReviewsPendingAction(payload));

  try {
    const res = await Api.getReviews(payload);
    dispatch(getReviewsFulfilledAction(res));
  } catch (err) {
    dispatch(getReviewsRejectedAction(err));
  }
};
